import { render } from "./NFTList.vue?vue&type=template&id=0ead6c9f&ts=true"
import script from "./NFTList.vue?vue&type=script&lang=ts"
export * from "./NFTList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__